import { IDeveloperDto } from "./DeveloperDto";

export interface IDevelopersDto {
  developers: IDeveloperDto[] | undefined;
}

export class DevelopersDto implements IDevelopersDto {
  public developers: IDeveloperDto[];

  constructor() {
    this.developers = new Array<IDeveloperDto>();
  }
}